'use client';

import React from 'react';
import { useTranslations } from 'use-intl';
import { DashboardProps } from './types';

// Per EWM-176, the My Account redesign drops the left sidebar in
// favour of pill-tab navigation inside `<DashboardPage>`. The
// existing dashboard sub-page tastics (orders / addresses / quotes /
// settings / company-admin / etc.) still wrap their content in this
// shell — they now render in normal flow without nav, and the tabbed
// /account page is the canonical entry point. The optional `title`
// prop is preserved for those legacy pages so their H1 still renders.
const Dashboard = ({ title, children }: React.PropsWithChildren<DashboardProps>) => {
  const translate = useTranslations();

  return (
    <div className="box-border min-h-[calc(100vh-131px)] max-w-full px-4 pb-6 md:px-5 md:pb-7 lg:min-h-[calc(100vh-83px)] lg:px-12 lg:pb-9">
      {title && (
        <h1 className="md:text-20 lg:text-24 py-6 text-lg font-bold text-gray-700 md:py-7 lg:py-9">
          {
            // eslint-disable-next-line
            // @ts-ignore
            translate(title)
          }
        </h1>
      )}
      {children}
    </div>
  );
};

export default Dashboard;
